export default "__VITE_ASSET__0h7mCI9q__"